interface PageNumberProps {
  number: string | number;
  className?: string;
  onClick?: () => void;
}

const PageNumber: React.FC<PageNumberProps> = ({ number, className, onClick }) => {
  const pageNumberClasses = `flex items-center justify-center px-1 text-sm text-custom-darkSilver cursor-pointer ${
    className ?? ''
  }`;

  return (
    <div className={pageNumberClasses} onClick={onClick}>
      {number}
    </div>
  );
};

export default PageNumber;
